(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eg-quick-add"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.EGQuickAdd) return;
    window.EGQuickAdd = true;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function idx(box, name) {
      var v = box.getAttribute('data-' + name);
      return v === null || v === '' ? -1 : parseInt(v, 10);
    }
    function variants(box) {
      if (box._egqa) return box._egqa;
      var el = box.querySelector('[data-egqa-variants]');
      try { box._egqa = el ? JSON.parse(el.textContent) : []; } catch (e) { box._egqa = []; }
      return box._egqa;
    }
    function activeColour(box) {
      var c = box.querySelector('[data-egqa-colour].is-active');
      return c ? c.getAttribute('data-egqa-colour') : null;
    }
    function findVariant(box, size) {
      var si = idx(box, 'size-index'), ci = idx(box, 'colour-index'), colour = activeColour(box);
      var list = variants(box);
      for (var i = 0; i < list.length; i++) {
        var v = list[i];
        if (v.o[si] !== size) continue;
        if (ci > -1 && colour !== null && v.o[ci] !== colour) continue;
        if (v.a) return v;
      }
      return null;
    }
    function refreshSizes(box) {
      box.querySelectorAll('[data-egqa-size]').forEach(function (b) {
        var ok = !!findVariant(box, b.getAttribute('data-egqa-size'));
        b.disabled = !ok;
        b.classList.toggle('is-sold', !ok);
        if (!ok) b.classList.remove('is-selected');
      });
    }
    function flash(btn, text, ms) {
      btn.textContent = text;
      clearTimeout(btn._t);
      btn._t = setTimeout(function () {
        btn.textContent = btn.getAttribute('data-label') || 'Quick add +';
        btn.disabled = false;
      }, ms);
    }
    function swapDrawer(html) {
      var cur = document.getElementById('CartDrawer');
      if (!cur) return false;
      if (!html) return true;
      var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('CartDrawer');
      if (!fresh) return true;
      var t = cur.querySelector('.cart-drawer__title'), nt = fresh.querySelector('.cart-drawer__title');
      if (t && nt) t.textContent = nt.textContent;
      Array.prototype.slice.call(cur.children).forEach(function (c) {
        if (!c.classList.contains('cart-drawer__header')) c.remove();
      });
      Array.prototype.slice.call(fresh.children).forEach(function (c) {
        if (!c.classList.contains('cart-drawer__header')) cur.appendChild(document.importNode(c, true));
      });
      return true;
    }
    function updateCount() {
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var el = document.getElementById('CartCount');
          if (!el) return;
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        }).catch(function () {});
    }
    function openDrawer() {
      var opener = document.querySelector('[data-open-cart]');
      if (opener) opener.click(); else window.location.href = root + 'cart';
    }
    function add(btn, id) {
      btn.disabled = true;
      btn.textContent = 'Adding';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer', sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function (d) {
          var html = d.sections && d.sections['cart-drawer'];
          var getHtml = html ? Promise.resolve(html)
            : fetch(root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (s) { return s['cart-drawer']; }).catch(function () { return null; });
          return getHtml.then(function (h) {
            var hasDrawer = swapDrawer(h);
            updateCount();
            flash(btn, 'Added', 1800);
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            if (hasDrawer) openDrawer(); else window.location.href = root + 'cart';
          });
        })
        .catch(function (err) {
          flash(btn, err && err.status === 422 ? 'Sold out' : 'Try again', 2200);
        });
    }

    document.addEventListener('click', function (e) {
      var colour = e.target.closest('[data-egqa-colour]');
      if (colour) {
        e.preventDefault();
        var cbox = colour.closest('[data-egqa]');
        cbox.querySelectorAll('[data-egqa-colour]').forEach(function (b) { b.classList.remove('is-active'); });
        colour.classList.add('is-active');
        refreshSizes(cbox);
        return;
      }

      var size = e.target.closest('[data-egqa-size]');
      if (size) {
        e.preventDefault();
        if (size.disabled) return;
        var sbox = size.closest('[data-egqa]');
        var was = size.classList.contains('is-selected');
        sbox.querySelectorAll('[data-egqa-size]').forEach(function (b) { b.classList.remove('is-selected'); });
        if (!was) size.classList.add('is-selected');
        sbox.classList.remove('needs-size');
        return;
      }

      var btn = e.target.closest('[data-egqa-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled) return;
      var box = btn.closest('[data-egqa]');

      if (btn.hasAttribute('data-variant-id')) {
        add(btn, parseInt(btn.getAttribute('data-variant-id'), 10));
        return;
      }

      var picked = box.querySelector('[data-egqa-size].is-selected');
      if (!picked) {
        box.classList.remove('needs-size');
        void box.offsetWidth;
        box.classList.add('needs-size');
        flash(btn, 'Select a size', 1600);
        return;
      }
      var v = findVariant(box, picked.getAttribute('data-egqa-size'));
      if (!v) { flash(btn, 'Sold out', 1800); return; }
      add(btn, v.id);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
